import QuoteAPICall from "src/service/QuoteAPICall";
import ProductRepository from "./ProductRepository";
import Helper from "../helper/Helper";
import Constants from "src/helper/Constants";

const { currencyType: { USD } } = Constants
class QuoteRepository {

    getOpenQuoteList = async (params = {}) => {
        let resp = {}
        let lineItems = await new QuoteAPICall().getOpenQuoteList(params);
        if (lineItems?.data?.quoteItems) {
            if (_.isArray(lineItems.data.quoteItems)) {
                let quoteLineItems = {};
                lineItems.data.quoteItems.map((v) => {
                    let data = {
                        customerPartNumber: v?.customerPartNumber,
                        ERPManufacturerCode: v.erpManufacturerCode,
                        ERPPartNumber: v.partNumber,
                        ItemNumber: v.itemNumber,
                        ManufacturerName: v.manufacturerName,
                        quantity1: v.quantity1,
                        quantity2: v.quantity2,
                        quantity3: v.quantity3,
                        quoteLineItemId: v.quoteLineItemId,
                        targetCurrency: USD,
                        targetUnitPrice: v.targetUnitPrice,
                        ERPMFRPartNumber: v.erpManufacturerPartNumber,
                        uniqueId: v.quoteLineItemId

                    }
                    let quoteLineItemId = " " + v.quoteLineItemId;
                    quoteLineItems[quoteLineItemId] = data;
                });

                new ProductRepository().getProductPriceInventoryAssets(quoteLineItems, { currency: USD });
                resp.openQuoteList = { count: lineItems.data.total, records: quoteLineItems };
            }
        } else {
            resp.openQuoteList = { count: 0, records: [] };
        }
        return resp;
    };

    get_Dowpdown_List = async (params = {}) => {
        return await new QuoteAPICall().get_Dowpdown_List();
    }

    get_Project_Data = async (params = {}) => {
        return await new QuoteAPICall().get_Project_Data();
    }

    addUpdateProjectData = async (params) => {
        return await new QuoteAPICall().addUpdateProjectData(params)
    };

    submitQuote = async (params) => {
        return await new QuoteAPICall().submitQuote(params)
    };

    clearAllQuote = async () => {
        return await new QuoteAPICall().clearAllQuote();
    };

    clearSingleQuote = async (quoteId) => {
        return await new QuoteAPICall().clearSingleQuote(quoteId);
    };

    addOpenQuote = async (quote) => {
        return await new QuoteAPICall().addQuote(quote)
    };

    editQuoteSave = async (quote) => {
        let quoteResponse = {};
        if (quote && Object.entries(quote).length > 0) {
            quoteResponse = await new QuoteAPICall().editQuote(quote)
        }
        return quoteResponse;
    };

    getSubmittedQuoteList = async (params) => {
        return await new QuoteAPICall().getSubmittedQuoteList(params)
    };

    searchQuote = async (params) => {
        const res = await new QuoteAPICall().searchQuote(params);
        if (!res) {
            return res;
        }
        const args = res.records.map((product) => ({
            ...product,
            ERPPartNumber: product.sapMaterialId,
        }));
        await new ProductRepository().getProductPriceInventoryAssets(args, {
            isPriceCall: false,
            isInventoryCall: false,
        })
        return { records: args, totalRecords: res?.totalRecords };
    };

    addMultipleQuote = async (payload) => {
        const { product, quoteList, pricing_list, quoteFrom = "Quote" } = payload
        const priceList = (id) => {
            return pricing_list[id]?.pricing
        }
        if (quoteList && Object.values((quoteList).length > 0)) {
            let params = {}
            const QuoteListItem = []
            if (quoteFrom === "Quote") {
                Object.entries(quoteList).map(obj => {
                    const data = {
                        "partNumber": obj[1]?.ERPPartNumber,
                        "erpManufacturerPartNumber": product[obj[1]?.ERPPartNumber]?.ERPMFRPartNumber,
                        "itemNumber": product[obj[1]?.ERPPartNumber]?.ItemNumber,
                        "erpManufacturerCode": product[obj[1].ERPPartNumber]?.ERPManufacturerCode,
                        "manufacturerName": product[obj[1]?.ERPPartNumber]?.ManufacturerName,
                        "customerPartNumber": obj[1]?.customerPartnumber,
                        "quantity1": new QuoteRepository().getRFQMinQty(product[obj[1]?.ERPPartNumber], priceList(product[obj[1]?.ERPPartNumber]?.ItemNumber)) || null,
                        "targetCurrency": USD,
                        "targetUnitPrice": obj[1]?.targetPrice_quantity_1 || null,
                        "endCustomer": obj[1]?.endCustomerName,
                        "competition": null,
                        "comments": obj[1]?.comments
                    }
                    QuoteListItem.push(data)
                })
            }

            params.lineItems = quoteFrom === "Quote" ? QuoteListItem : quoteList
            return await new QuoteAPICall().addQuoteInBulk(params)
        }
    }

    getRFQMinQty = (product, priceList) => {
        // pricing is greater > min / mult = min qy = 250000 plus the mult
        // pricing is < than min / mult =
        // Price not avialble = (with regular in/mult)
        let qty = product?.QtyMin;
        if (priceList && priceList.length) {
            const leastPriceQty = priceList[priceList.length - 1].quantity
            if (leastPriceQty > product.QtyMin) { // Case : 1 - leastPriceQty > min
                qty = leastPriceQty + product.QtyMult;
            } else if (leastPriceQty <= product.QtyMin) { // Case : 2 - leastPriceQty < min
                qty = product.QtyMin + product.QtyMult
            }
            qty = Helper.roundOne(qty, product.QtyMult);
        }
        return qty;
    }

    getSubmittedQuoteExportUrl = async (params = {}) => {
        return await new QuoteAPICall().getSubmittedQuoteExportUrl(params);
    };

    getLineItemsDetail = async (params) => {
        return await new QuoteAPICall().getLineItemsDetail(params);
    };

    setSelectAllQty = async (quoteOrgList, selectedList, quoteCurentStatus, productList) => {
        let selectedQty = "";

        if (selectedList && Object.entries(selectedList).length > 0 && quoteOrgList && Object.entries(quoteOrgList).length > 0) {
            const totalCountQty1 = Object.entries(quoteOrgList).filter(v => v[1].sellQuantity_quantity_1 > 0 && v[1]?.ERPPartNumber && productList[v[1]?.ERPPartNumber]).length;
            const selectedQty1 = Object.entries(selectedList).filter(v => v[1].quantity_field_selected === "quantity_1" && v[1].status === quoteCurentStatus && v[1]?.ERPPartNumber).length;

            if (selectedQty1 > 0 && totalCountQty1 === selectedQty1) {
                selectedQty = "quantity_1"
            }
            else {
                // check for Qty 2
                const totalCountQty2 = Object.entries(quoteOrgList).filter(v => v[1].sellQuantity_quantity_2 > 0 && v[1]?.ERPPartNumber && productList[v[1]?.ERPPartNumber]).length;
                const selectedQty2 = Object.entries(selectedList).filter(v => v[1].quantity_field_selected === "quantity_2" && v[1].status === quoteCurentStatus && v[1]?.ERPPartNumber).length;
                if (selectedQty2 > 0 && totalCountQty2 === selectedQty2) {
                    selectedQty = "quantity_2"
                } else {
                    const totalCountQty3 = Object.entries(quoteOrgList).filter(v => v[1].sellQuantity_quantity_3 > 0 && v[1]?.ERPPartNumber && productList[v[1]?.ERPPartNumber]).length;
                    const selectedQty3 = Object.entries(selectedList).filter(v => v[1].quantity_field_selected === "quantity_3" && v[1].status === quoteCurentStatus && v[1]?.ERPPartNumber).length;

                    if (selectedQty3 > 0 && totalCountQty3 === selectedQty3) {
                        selectedQty = "quantity_3"
                    }
                }
            }

        }
        return selectedQty;
    }

    sendSubmittedQuoteEmail = async (params = {}) => {
        return await new QuoteAPICall().sendSubmittedQuoteEmail(params);
    }
}

export default QuoteRepository;